import { Component, OnInit } from '@angular/core';
import { ReportsService } from '../reports.service';
import { DomSanitizer } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-embed-report',
    templateUrl: './embed-report.component.html',
    styleUrls: ['./embed-report.component.css'],
    imports: [RouterLink]
})
export class EmbedReportComponent implements OnInit {
  ReportName:any;
  report: any;
  HTML: any;
  constructor(private reportsService: ReportsService,private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
  this.ReportName=  decodeURIComponent(window.location.href.substring(window.location.href.lastIndexOf('/') + 1));
  this.reportsService.getReport(this.ReportName).subscribe(result => {
    if (result.length > 0) {
      this.report = result[0];
      this.HTML =  this.sanitizer.bypassSecurityTrustHtml(this.report.Embed_link);
    }

  });
  }

}
